/**
 * Экранная клавиатура кассы.
 *
 * На Windows-планшете системная клавиатура не всплывает при касании
 * поля: в режиме ноутбука её нет вовсе, а в планшетном она зависит
 * от настройки, которую никто не включал. На кассовых терминалах
 * физической клавиатуры часто нет совсем.
 *
 * Поэтому своя: всегда на месте, всегда одинаковая, с раскладкой
 * под то, что здесь набирают — названия блюд по-русски и цифры.
 *
 * Включается в настройках устройства: у кого планшет с работающей
 * системной клавиатурой, тому вторая только мешает.
 */
import { useState } from 'react';

const RU_ROWS = [
  ['й','ц','у','к','е','н','г','ш','щ','з','х'],
  ['ф','ы','в','а','п','р','о','л','д','ж','э'],
  ['я','ч','с','м','и','т','ь','б','ю'],
];

const EN_ROWS = [
  ['q','w','e','r','t','y','u','i','o','p'],
  ['a','s','d','f','g','h','j','k','l'],
  ['z','x','c','v','b','n','m'],
];

const DIGITS = ['1','2','3','4','5','6','7','8','9','0'];

export function OnScreenKeyboard({
  onKey, onBackspace, onClear, onClose, digitsOnly = false,
}: {
  onKey: (ch: string) => void;
  onBackspace: () => void;
  onClear: () => void;
  onClose: () => void;
  /** только цифры: суммы, коды, телефоны. Буквы там мешают */
  digitsOnly?: boolean;
}) {
  const [lang, setLang] = useState<'ru' | 'en'>('ru');
  const rows = lang === 'ru' ? RU_ROWS : EN_ROWS;

  return (
    /*
     * Клик с клавиши НЕ должен всплывать выше клавиатуры.
     *
     * В окнах-шторках клавиатура стоит на фоне, а фон закрывается
     * по клику (тап мимо окна = отмена). Клик с любой клавиши
     * пузырился до фона — буква вписывалась, и тут же окно
     * закрывалось вместе с клавиатурой: «одну букву нажал —
     * исчезла». Глушим только всплытие; сами клики клавиш работают
     * как работали, preventDefault здесь не нужен и вреден.
     */
    <div className="osk" onClick={(e) => e.stopPropagation()}>
      <div className="osk-row osk-digits">
        {DIGITS.map((d) => (
          <button key={d} onClick={() => onKey(d)}>{d}</button>
        ))}
      </div>

      {!digitsOnly && rows.map((row, i) => (
        <div key={i} className="osk-row">
          {row.map((ch) => (
            <button key={ch} onClick={() => onKey(ch)}>{ch}</button>
          ))}
        </div>
      ))}

      {/* Символы адреса и почты: первый экран программы — адрес сервера,
          дальше почта гостя и код активации. Без точки, дефиса, собачки
          и косой черты их не набрать, а другой клавиатуры на планшете нет */}
      {!digitsOnly && (
        <div className="osk-row">
          {['.', ',', '-', '_', '@', ':', '/'].map((ch) => (
            <button key={ch} onClick={() => onKey(ch)}>{ch}</button>
          ))}
        </div>
      )}

      <div className="osk-row osk-bottom">
        {digitsOnly ? (
          <>
            {/* Запятая нужна весу и дробным суммам, точка — привычка
                тех, кто печатал на компьютере */}
            <button className="osk-wide" onClick={() => onKey(',')}>,</button>
            <button className="osk-space" onClick={() => onKey('0')}>0</button>
          </>
        ) : (
          <>
            <button className="osk-wide" onClick={() => setLang(lang === 'ru' ? 'en' : 'ru')}>
              {lang === 'ru' ? 'EN' : 'РУ'}
            </button>
            <button className="osk-space" onClick={() => onKey(' ')}>пробел</button>
          </>
        )}
        <button className="osk-wide" onClick={onBackspace}>←</button>
        <button className="osk-wide" onClick={onClear}>Стереть</button>
        <button className="osk-wide osk-hide" onClick={onClose}>Скрыть</button>
      </div>
    </div>
  );
}
